/** CoStar.Api.AptsNet.Aggregate.ViewModels.RegisterUser.UserNotificationMediums */
export var UserNotificationMediums;
(function (UserNotificationMediums) {
    UserNotificationMediums[UserNotificationMediums["None"] = 0] = "None";
    UserNotificationMediums[UserNotificationMediums["Email"] = 1] = "Email";
    UserNotificationMediums[UserNotificationMediums["Sms"] = 2] = "Sms";
})(UserNotificationMediums || (UserNotificationMediums = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.RegisterUser.ExternalProvider */
export var ExternalProvider;
(function (ExternalProvider) {
    ExternalProvider[ExternalProvider["Unknown"] = 0] = "Unknown";
    ExternalProvider[ExternalProvider["Google"] = 1] = "Google";
    ExternalProvider[ExternalProvider["Facebook"] = 2] = "Facebook";
})(ExternalProvider || (ExternalProvider = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.RegisterUser.ExternalProviders */
export var ExternalProviders;
(function (ExternalProviders) {
    ExternalProviders[ExternalProviders["None"] = 0] = "None";
    ExternalProviders[ExternalProviders["Google"] = 1] = "Google";
    ExternalProviders[ExternalProviders["Facebook"] = 2] = "Facebook";
})(ExternalProviders || (ExternalProviders = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.RegisterUser.NotificationFrequency */
export var NotificationFrequency;
(function (NotificationFrequency) {
    NotificationFrequency[NotificationFrequency["None"] = 0] = "None";
    NotificationFrequency[NotificationFrequency["Immediately"] = 1] = "Immediately";
    NotificationFrequency[NotificationFrequency["Daily"] = 2] = "Daily";
    NotificationFrequency[NotificationFrequency["Weekly"] = 3] = "Weekly";
})(NotificationFrequency || (NotificationFrequency = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.RegisterUser.NotificationSubscriptions */
export var NotificationSubscriptions;
(function (NotificationSubscriptions) {
    NotificationSubscriptions[NotificationSubscriptions["None"] = 0] = "None";
    NotificationSubscriptions[NotificationSubscriptions["Favorites"] = 1] = "Favorites";
    NotificationSubscriptions[NotificationSubscriptions["SavedSearches"] = 2] = "SavedSearches";
    NotificationSubscriptions[NotificationSubscriptions["WeeklyPropertyActivityReport"] = 4] = "WeeklyPropertyActivityReport";
    NotificationSubscriptions[NotificationSubscriptions["MonthlyPropertyActivityReport"] = 8] = "MonthlyPropertyActivityReport";
})(NotificationSubscriptions || (NotificationSubscriptions = {}));
